import ManageECheck from './ManageECheck';
import { connect } from 'react-redux';

import {
  IPagination,
  IPaymentFilters
} from 'src/services/paySimple/paySimpleService';

import {
  dataSel,
  pageNumberSel,
  pageSizeSel,
  totalElementsSel,
  totalPagesSel,
  isPendingSel,
  paymentsActions
} from 'src/store/modules/payments';

const mapStateToProps = (state: any) => ({
  data: dataSel(state),
  pageNumber: pageNumberSel(state),
  pageSize: pageSizeSel(state),
  totalElements: totalElementsSel(state),
  totalPages: totalPagesSel(state),
  isPending: isPendingSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getPayments: (
    filters: IPaymentFilters,
    pagination: IPagination,
    sort: any
  ): any => {
    dispatch(paymentsActions.getPayments(filters, pagination, sort));
  }
});

export const pureComponent = ManageECheck;

export default connect(mapStateToProps, mapDispatchToProps)(ManageECheck);
